module.exports = __webpack_public_path__ + "tg.svg?bf2a3047a97d8d43b9f790879678a94e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/tg.svg
// module id = 950
// module chunks = 27